<template>
  <v-form>
    <v-container>
      <div style="height: 10px;"></div>

      <v-layout row wrap>
        <v-flex xs12 sm4>
          <v-select
            v-model="selectSupplier"
            :items="suppliers"
            label="取引先選択"
            item-text="supplierName"
            item-value="supplierCode"
            :sort-by="['supplierCode']"
            :sort-desc="[false]"
            return-object
            :disabled="isZumiUser"
          ></v-select>
        </v-flex>
      </v-layout>

      <v-layout row wrap justify-space-between>
        <!-- 달력 -->
        <v-flex xs12 sm4>
          <v-menu
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="shippingDate"
                label="店着日"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="shippingDateForPicker"
              @input="menu1 = false"
              locale="jp-ja"
              :day-format="shippingDate => new Date(shippingDate).getDate()"
              no-title
              @change="changeShippingDate()"
              :events="functionEvents"
              :event-color="eventColorFunction" 
            ></v-date-picker>
          </v-menu>
        </v-flex>

        <!-- 발주 락/해제 버튼 -->
        <v-layout row wrap justify-space-between>
          <v-flex xs8 sm4 align-self-center>
            <v-btn
              block
              color="error"
              @click="orderLock()"
              v-if="!isZumiUser && ('0' === orderLocked || null == orderLocked)"
              v-bind:disabled="disabledOrderLockBtn"
            >
              <v-icon dark left>lock</v-icon>発注ロック
            </v-btn>

            <v-btn
              block
              color="success"
              @click="orderUnlock()"              
              v-else-if="!isZumiUser"
              v-bind:disabled="disabledOrderLockBtn"
            >
              <v-icon dark left>lock_open</v-icon>発注ロック解除
            </v-btn>
          </v-flex>

          <!-- 갱신 버튼 -->
          <v-flex xs8 sm4 align-self-center>
            <v-btn 
              v-if="!isZumiUser"
              block 
              color="info" 
              @click="update()"
            >
              <v-icon dark left>update</v-icon>更新
            </v-btn>
          </v-flex>
        </v-layout>
      </v-layout>

      <v-data-table
        :headers="headers"
        :items="orders"
        class="elevation-1"
        :custom-sort="orderMgmIdSort"
        hide-actions
        :loading="loadingData"
        :customFilter="customFilter"
        :search="selectSupplier"
      >
        <!-- 헤더 -->
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">{{ props.header.text }}</span>
            </template>
            <span>{{ props.header.text }}</span>
          </v-tooltip>
        </template>

        <!-- 데이타 -->
        <template v-slot:items="props">
          <tr v-if="props.item.stockLockDate == null && props.item.createdAt != null" style="background-color: #ffa500;">
            <td class="text-xs-left" @click="forwardOrderAccept(props.item)">{{ props.item.storeName }}</td>
            <td class="text-xs-center" @click="forwardOrderAccept(props.item)" >{{ props.item.createdAt }}</td>
            <td class="text-xs-center" @click="forwardOrderAccept(props.item)">
              <v-icon v-if="props.item.hasImage">mobile_friendly</v-icon>
            </td>
            <td class="text-xs-left" @click="forwardOrderAccept(props.item)" >{{ props.item.slipNumber }}</td>
            <td class="text-xs-left" @click="forwardOrderAccept(props.item)" >{{ props.item.createdUser }}</td>
            <td class="text-xs-left"> 
              <v-icon v-if="'1' === props.item.region1IsLocked">lock</v-icon>
            </td>
            <td class="text-xs-left">
              <v-icon v-if="'1' === props.item.region2IsLocked">lock</v-icon>
            </td>
            <td class="text-xs-left">
              <v-flex xs3 sm3>
                <v-btn
                  v-if="!isZumiUser"
                  block
                  color="error"
                  dark
                  v-bind:disabled="0 === props.item.orderManagementId"
                  @click="deleteOrderDialog(props.item)"
                >
                  <v-icon dark left>delete_forever</v-icon>削除
                </v-btn>
              </v-flex>
            </td>
          </tr>
          <tr v-else>
            <td class="text-xs-left" @click="forwardOrderAccept(props.item)">{{ props.item.storeName }}</td>
            <td class="text-xs-center" @click="forwardOrderAccept(props.item)" >{{ props.item.createdAt }}</td>
            <td class="text-xs-center" @click="forwardOrderAccept(props.item)">
              <v-icon v-if="props.item.hasImage">mobile_friendly</v-icon>
            </td>
            <td class="text-xs-left" @click="forwardOrderAccept(props.item)" >{{ props.item.slipNumber }}</td>
            <td class="text-xs-left" @click="forwardOrderAccept(props.item)" >{{ props.item.createdUser }}</td>
            <td class="text-xs-left"> 
              <v-icon v-if="'1' === props.item.region1IsLocked">lock</v-icon>
            </td>
            <td class="text-xs-left">
              <v-icon v-if="'1' === props.item.region2IsLocked">lock</v-icon>
            </td>
            <td class="text-xs-left">
              <v-flex xs3 sm3>
                <v-btn
                  v-if="!isZumiUser"
                  block
                  color="error"
                  dark
                  v-bind:disabled="0 === props.item.orderManagementId"
                  @click="deleteOrderDialog(props.item)"
                >
                  <v-icon dark left>delete_forever</v-icon>削除
                </v-btn>
              </v-flex>
            </td>
          </tr>
        </template>
      </v-data-table>

      <div style="height: 35px;"></div>

      <v-layout row wrap>
        <v-flex xs4 sm2>
          <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-admin-menu' }">
            <v-icon color="black" left>home</v-icon>Home
          </v-btn>
        </v-flex>
        <v-flex xs4 sm2 ></v-flex>
        <v-flex xs4 sm4 ></v-flex>
        <v-flex 
          v-if="!isZumiUser" 
          xs4 
          sm2 
        >
          <v-text-field 
            v-model="orderId" 
            label="Order ID" 
            variant="underlined" 
            clearable >
          </v-text-field>
        </v-flex>
        <v-flex
          v-if="!isZumiUser"  
          xs4 
          sm2 
        >
          <v-btn            
            block 
            color="primary" 
            dark 
            @click="downloadConfirm()"
          >
            <v-icon dark left>get_app</v-icon>ダウンロード
          </v-btn>
        </v-flex>
      </v-layout>      
    </v-container>

    <v-dialog max-width="300px" v-model="deleteDialog">
      <!-- v-model="dialog1" -->
      <v-card>
        <v-container>
          <v-card-title>
            <span style="margin: 0 auto 0;">削除しますか</span>
          </v-card-title>
          <v-layout row wrap style="margin-bottom:20px;">
            <v-flex xs12 sm12>
              <v-btn color="error" text @click="deleteOrder()">削除</v-btn>
              <v-btn text @click.stop="deleteDialog = false">戻る</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'
import ServerApiCallService from '@/services/ServerApiCallService.js'
import moment from 'moment-timezone'
import axios from 'axios'

export default {
  created() {
    console.log('created')
    let thisObj = this

    clearInterval(this.$store.state.adminSession.orderConfirmIntervalId);

    // 모든 거래처 정보 가져오기
    ServerApiCallService.suppliers()
      .then(response => {
        thisObj.suppliers = response.data.suppliers

        thisObj.suppliers.unshift({
          supplierCode: '#',
          supplierName: '全て(使える店舗)'
        })
        
        thisObj.suppliers.splice(1,0,{
          supplierCode: 'r',
          supplierName: '使えない店舗'
        })


      })      
      .catch(error => {
        console.log('There was an error:', error.response)
      }
    )

    if (this.shippingDate == '') {
      this.shippingDate = moment().format('YYYY/MM/DD')
    }

    if (this.shippingDate != '') {
      let request = { shippingDate: this.shippingDate.replace(/\//g, '') }
      this.getOrdersByDay(thisObj, request)      
      this.startInterval(thisObj, request)
    }
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),

    isZumiUser() {
      const authority = this.user && this.user.adminRole
      return String(authority) === '9'
    },

    shippingDate: {
      get() {
        let shippingDate = this.$store.state.adminSession
          .orderConfirmSelectedShippingDate
        if (shippingDate == null) {
          return moment().format('YYYY/MM/DD')
        }
        return shippingDate
      },
      set(value) {
        this.$store.commit('SET_ORDER_CONFIRM_SELECTED_SHIPPING_DATE', value)
      }
    },
    orderAcceptOrderManagementId: {
      get() {
        return this.$store.state.adminSession.orderAcceptOrderManagementId
      },
      set(value) {
        this.$store.commit('SET_ORDER_ACCEPT_ORDER_MANAGEMENT_ID', value)
      }
    }
  },

  watch: {
    isZumiUser: {
      immediate: true,
      handler(value) {
        if (value) {
          this.selectSupplier = this.zumiSupplier
        }
      }
    }
  },
  methods: {
    orderMgmIdSort(items, index, isDesc) {
      items.sort((a, b) => {
        if (!isDesc) {
          if (a.orderManagementId < b.orderManagementId) {
            return 1;
          } else if (a.orderManagementId > b.orderManagementId) {
            return -1;
          }
        } else {
          if (a.orderManagementId < b.orderManagementId) {
            return -1;
          } else if (a.orderManagementId > b.orderManagementId) {
            return 1;
          }
        }
        return 0;
      })
      return items;
    },
    downloadConfirm() {
      if (isNaN(this.orderId)) {
        alert('数字のみ入力してください')
        return
      }

      if (this.orderId < 0) {
        alert('注文番号を確認してください')
        return
      }

      let request = { 
        shippingDate: this.shippingDate.replace(/\//g, ''),
        orderManagementId: this.orderId
      }      
     
      ServerApiCallService.downloadConfirm(request)
        .then(response => {

          // 주문번호를 입력한 경우
          if (this.orderId != '' ) {
            // 주문번호가 있는 경우
            if (response.data) {    
              // 주분번호가 있으면 shipping date는 필요 없기에 삭제를 한다
              this.shippingDate = ''
              this.downloadCsv()
            } else {
              // 주문번호를 입력했는데 주문번호가 없는경우
              alert("注文番号を確認してください")
              return
            }
          } else {
            // 주문번호가 없으면 조건없이 출력
            let tmpShippingDate = this.shippingDate.replace(/\//g, '')
            this.shippingDate = tmpShippingDate
            this.downloadCsv()
          }
        })
        .catch(error => {
          console.log('There was an error(downloadConfirm):', error.response)
        })
    },
    downloadCsv() {
      console.log("downloadCSV");      
      
      let request = { 
        shippingDate: this.shippingDate,
        orderManagementId: this.orderId
      }    

      axios
        .create({
          baseURL: ServerApiCallService.getServerUrl(),
          withCredentials: false,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json;charset=utf-8',
            accessToken: window.localStorage.getItem('accessToken')
          }
        })
        .post('/admin/new-order-confirm-download', request, {
          responseType: 'blob',
        })
        .then(({ data }) => {
          let blob = new Blob([data], { type: 'text/csv' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          if (this.shippingDate == '') {
            link.download = this.orderId + '_発注依頼.csv'
          } else{
            link.download = this.shippingDate + '_発注依頼.csv'
          }
          
          link.click()
        })
        .catch(error => {
          alert("システム担当者にお問い合わせください")
          console.log('There was an error:', error.response)
        })
    },
    getOrdersByDay(thisObj, request) {
      this.loadingData = true
      
      ServerApiCallService.ordersByDay(request)
        .then(response => {          
          thisObj.orders = response.data.orders

          // 선택한 날짜의 주문데이타가 있는 점포만 가져온다
          thisObj.orders.forEach(function(row) {
            // 주문데이타 생성일자를 포멧팅 한다
            if (row.createdAt != null) {
              let formattedCreatedAt = row.createdAt.substring(0, 4) + '/' + row.createdAt.substring(4, 6) + '/' + row.createdAt.substring(6, 8) + ' ' 
                                      + row.createdAt.substring(8, 10) + ':' + row.createdAt.substring(10, 12) 
              row.createdAt = formattedCreatedAt
            }
          })
          
          if ( moment(this.shippingDate, 'YYYY-MM-DD').format('YYYYMMDD') < moment().format('YYYYMMDD')) {
            this.disabledOrderLockBtn = true
          } else {
            this.disabledOrderLockBtn = false
          }
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
      this.existsOrders()
      this.existsUnlockedOrders()
      this.getOrderStatus()
      this.loadingData = false
    },
    changeShippingDate() {
      console.log('change shipping date')
      // 카렌다에서 선택한 날짜('-'' -> '/'로 변경)
      this.shippingDate = this.shippingDateForPicker.replace(/-/g, '/')
      let thisObj = this
      let request = {
        shippingDate: this.shippingDate.replace(/\//g, '')
      }
      this.getOrdersByDay(thisObj, request)
      clearInterval(this.$store.state.adminSession.orderConfirmIntervalId)
      this.startInterval(thisObj, request)
    },
    forwardOrderAccept: function(item) {
      clearInterval(this.$store.state.adminSession.orderConfirmIntervalId)
      if (0 === item.orderManagementId) return
      this.orderAcceptOrderManagementId = item.orderManagementId
      this.$router.push({
        name: 'admin/new-order-accept',
        params: {
          // orderManagementId: item.orderManagementId
        }
      })
    },
    deleteOrderDialog(selectedOrder) {
      if (this.isZumiUser) {  
        return
      }

      this.selectedOrder = selectedOrder
      this.deleteDialog = true
    },
    deleteOrder() {
      let request = {
        orderManagementId: this.selectedOrder.orderManagementId
      }

      ServerApiCallService.deleteOrder(request)
        .then(response => {
          let thisObj = this
          let request = {
            shippingDate: this.shippingDate.replace(/\//g, '')
          }
          this.getOrdersByDay(thisObj, request)
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
      this.deleteDialog = false
    },
    functionEvents(date) {
      // 주문이 있는 날짜만 true로 넘긴다
      var day = date.replace(/-/g, '');
      if (this.existsOrderData.includes(day)) return true
    },
    eventColorFunction(date) {
      // functionEvents에서 true로 넘어온 주문이 있는 날짜가 들어온다
      var day = date.replace(/-/g, '');
      if (this.existsUnlockedOrdersData.length > 0) {
        if (this.existsUnlockedOrdersData.includes(day)) {
          return 'red'
        } else {
          return 'green'
        }
      } else {
        return 'green'
      }
    },
    existsOrders() {
      let request = {
        shippingDate: this.shippingDate.replace(/\//g, '')
      }

      ServerApiCallService.existsOrdersByShippingDate(request)
        .then(response => {
          this.existsOrderData = response.data.existsOrders
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    existsUnlockedOrders() {
      let request = {
        shippingDate: this.shippingDate.replace(/\//g, '')
      }

      ServerApiCallService.existsUnlockedOrdersByShippingDate(request)
        .then(response => {
          this.existsUnlockedOrdersData = response.data.existsOrders
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    startInterval(thisObj, request) {
      this.timer = setInterval(() => {
        this.getOrdersByDay(thisObj, request)
      }, 60000)
      this.$store.commit('SET_ORDER_CONFIRM_INTERVAL_ID', this.timer)
    },
    update() {
      let thisObj = this
      let request = {
        shippingDate: this.shippingDate.replace(/\//g, '')
      }
      this.getOrdersByDay(thisObj, request)
    },
    getOrderStatus() {
      let request = {
        shippingDate: this.shippingDate.replace(/\//g, '')
      }

      ServerApiCallService.getOrderStatus(request)
        .then(response => {
          this.orderLocked = response.data.orderLocked
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    orderLock() {
      let request = {
        // 2024/03/04 -> 20240304로 변환
        shippingDate: this.shippingDate.replace(/\//g, '')
      }

      ServerApiCallService.orderLock(request)
        .then(response => {
          this.getOrderStatus()
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    orderUnlock() {
      console.log('order unlock date: ' + this.shippingDate.replace(/\//g, ''))
      let request = {
        shippingDate: this.shippingDate.replace(/\//g, '')
      }
      ServerApiCallService.orderUnlock(request)
        .then(response => {
          this.getOrderStatus()
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    // 검색조건 추가
    customFilter(items, search) {

      if (search.supplierName === '全て(使える店舗)') {
        let activeStores = items.filter(function(value) {
          if (value.isStoreDeleted === '0') {
            return true;
          } else {
            return false;
          }
        })

        return activeStores;
      } else if (search.supplierName === '使えない店舗') {
        let inactiveStores = items.filter(function(value) {
          if (value.isStoreDeleted === '1') {
            return true;
          } else {
            return false;
          }
        })
        
        return inactiveStores;
      } else {
        let filteringItems = items.filter(function(value) {          
          if (value.storeSupplierCode === search.supplierCode && value.isStoreDeleted === '0') {
            return true;
          } else {
            return false;
          }
        })
        
        return filteringItems;
      }
    },
  },  
  data() {
    return {
      menu1: false,
      shippingDateForPicker: '',
      orders: [],
      orderId: '',
      deleteDialog: false,
      selectedOrder: '',
      existsOrderData: [],
      existsUnlockedOrdersData: [],
      timer: '',
      loadingData: false,
      orderLocked: '',
      disabledOrderLockBtn: true,
      
      // 점포선택 추가
      selectSupplier: {
        supplierCode: '#',
        supplierName: '全て(使える店舗)'
      },
      // 검색 추가
      suppliers: [],

      // ZUMI 거래처 고정값
      zumiSupplier: {
        supplierCode: '93172',
        supplierName: 'ZUMI'
      },

      headers: [
        {
          text: '店舗名',
          align: 'left',
          value: 'storeName',
          width: '200px',
          fixed: true
        },
        {
          text: '発注日',
          align: 'center',
          sortable: false,
          value: 'createdAt',
          width: '50px',
          fixed: true
        },
        {
          text: '画像',
          align: 'center',
          sortable: false,
          value: 'hasImage',
          width: '30px'
        },
        {
          text: '伝票番号',
          align: 'left',
          sortable: false,
          value: 'slipNumber',
          width: '30px'
        },
        {
          text: '発注依頼者',
          align: 'left',
          sortable: false,
          value: 'createdUser',
          width: '30px'
        },
        {
          text: '三田',
          align: 'left',
          sortable: false,
          value: 'lockedRegion1',
          width: '10px'
        },
        {
          text: '千葉',
          align: 'left',
          sortable: false,
          value: 'lockedRegion2',
          width: '10px'
        },
        {
          text: '',
          align: 'left',
          sortable: false,
          value: 'delete',
          width: '20px'
        }
      ]
    }
  }
}
</script>

<style>
.hoge {
  width: 200px;
}
.column-input {
  width: 30px;
  height: 30px;
  text-align: right;
  border: 1px solid #c7c7c7;
  padding: 0 4px;
}
.v-btn--block dev {
  text-decoration: none;
}
.invisible-class-name {
  background-color: #b3e460;
}
</style>
